import { RSAA } from 'redux-api-middleware';
import uuid from 'node-uuid';
import { has, get, isEmpty } from 'lodash';
import {
	isRepeatingPayment,
	getBatchToSubmitForReview,
	getRepeatingPaymentToSubmitForReview,
	getPaymentsListToSubmitForReview,
	getPaymentsListToSubmitForDailyLimitReview,
	getConfirmedPaymentsToSubmit,
	getPaymentsTotal,
	getFromAccount,
	getFromAccounts,
	getPaymentContextId,
} from '../payments/selectors';
import { getPaymentCategory } from '../payments/getPaymentCategory';
import { getPaymentsList } from '../payments/getPaymentsList';
import {
	hasMissedDeadlineError,
	isConflictAndDailyLimitError,
	hasConflictError,
	hasServerError,
	getConflictResponse,
} from '../../helpers/apiResponse';
import { isPayingInternalAccountsWithoutBeneficiary } from '../payees/selectors';
import {
	isBatch,
	getBatchAuthorisation,
	getBatchName,
	getBatchId,
	getBatchAuthorisers,
	getBatchGroupAuthorisers,
	getBatchContextId,
	getBatchType,
	isBatchTypeUpload,
} from '../batch/selectors';
import { getBankId } from '../session/selectors';
import { isAuthorisationEdit } from '../modes/selectors';
import { submitBeneficiaries } from '../payees/actions';
import { TYPE_CHAPS } from '../../config';
import endpoints from '../../utils/endpoints';
import { getUserId } from '../user/selectors';
import { mapAuthorisersGroup } from '../../utils/authoriserUtils';

import {
	SUBMIT_BATCH_CHAPS_REVIEW_SUCCESS,
	SUBMIT_BATCH_CHAPS_REVIEW_REQUEST,
	SUBMIT_BATCH_CHAPS_REVIEW_FAILURE,
	SUBMIT_CHAPS_BATCH_REQUEST,
	SUBMIT_CHAPS_BATCH_SUCCESS,
	SUBMIT_CHAPS_BATCH_FAILURE,
	SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_REQUEST,
	SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_SUCCESS,
	SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_FAILURE,
} from './chapsActions';
import { getChunkingInfo } from './chunkingActions';
import { submitMultiPartChunkingRequest } from './submitMultiPartChunkingRequest';

const getAuthorisersPayload = (authorisationStatus, namedApprovers, groupApprovers) =>
	authorisationStatus === 'OBLIGATE' ? (namedApprovers.approver_id.length ? namedApprovers : groupApprovers) : null;

export const SUBMIT_PAYMENT_REVIEW_REQUEST = 'SUBMIT_PAYMENT_REVIEW_REQUEST';
export const SUBMIT_PAYMENT_REVIEW_SUCCESS = 'SUBMIT_PAYMENT_REVIEW_SUCCESS';
export const SUBMIT_PAYMENT_REVIEW_FAILURE = 'SUBMIT_PAYMENT_REVIEW_FAILURE';
export const SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_REQUEST = 'SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_REQUEST';
export const SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_SUCCESS = 'SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_SUCCESS';
export const SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_FAILURE = 'SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_FAILURE';
export const SUBMIT_CONFIRMED_PAYMENT_REQUEST = 'SUBMIT_CONFIRMED_PAYMENT_REQUEST';
export const SUBMIT_CONFIRMED_PAYMENT_SUCCESS = 'SUBMIT_CONFIRMED_PAYMENT_SUCCESS';
export const SUBMIT_CONFIRMED_PAYMENT_FAILURE = 'SUBMIT_CONFIRMED_PAYMENT_FAILURE';
export const SUBMIT_BATCH_REVIEW_REQUEST = 'SUBMIT_BATCH_REVIEW_REQUEST';
export const SUBMIT_BATCH_REVIEW_SUCCESS = 'SUBMIT_BATCH_REVIEW_SUCCESS';
export const SUBMIT_BATCH_REVIEW_FAILURE = 'SUBMIT_BATCH_REVIEW_FAILURE';
export const SUBMIT_CONFIRMED_BATCH_PAYMENTS_REQUEST = 'SUBMIT_CONFIRMED_BATCH_PAYMENTS_REQUEST';
export const SUBMIT_CONFIRMED_BATCH_PAYMENTS_SUCCESS = 'SUBMIT_CONFIRMED_BATCH_PAYMENTS_SUCCESS';
export const SUBMIT_CONFIRMED_BATCH_PAYMENTS_FAILURE = 'SUBMIT_CONFIRMED_BATCH_PAYMENTS_FAILURE';
export const SUBMIT_BATCH_REQUEST = 'SUBMIT_BATCH_REQUEST';
export const SUBMIT_BATCH_SUCCESS = 'SUBMIT_BATCH_SUCCESS';
export const SUBMIT_BATCH_FAILURE = 'SUBMIT_BATCH_FAILURE';
export const SUBMIT_REPEATING_PAYMENT_REVIEW_REQUEST = 'SUBMIT_REPEATING_PAYMENT_REVIEW_REQUEST';
export const SUBMIT_REPEATING_PAYMENT_REVIEW_SUCCESS = 'SUBMIT_REPEATING_PAYMENT_REVIEW_SUCCESS';
export const SUBMIT_REPEATING_PAYMENT_REVIEW_FAILURE = 'SUBMIT_REPEATING_PAYMENT_REVIEW_FAILURE';
export const SUBMIT_CONFIRMED_REPEATING_PAYMENT_REQUEST = 'SUBMIT_CONFIRMED_REPEATING_PAYMENT_REQUEST';
export const SUBMIT_CONFIRMED_REPEATING_PAYMENT_SUCCESS = 'SUBMIT_CONFIRMED_REPEATING_PAYMENT_SUCCESS';
export const SUBMIT_CONFIRMED_REPEATING_PAYMENT_FAILURE = 'SUBMIT_CONFIRMED_REPEATING_PAYMENT_FAILURE';
export const CANCEL_PAYMENT_APPROVAL_REQUEST = 'CANCEL_PAYMENT_APPROVAL_REQUEST';
export const CANCEL_PAYMENT_APPROVAL_SUCCESS = 'CANCEL_PAYMENT_APPROVAL_SUCCESS';
export const CANCEL_PAYMENT_APPROVAL_FAILURE = 'CANCEL_PAYMENT_APPROVAL_FAILURE';
export const CANCEL_BATCH_APPROVAL_REQUEST = 'CANCEL_BATCH_APPROVAL_REQUEST';
export const CANCEL_BATCH_APPROVAL_SUCCESS = 'CANCEL_BATCH_APPROVAL_SUCCESS';
export const CANCEL_BATCH_APPROVAL_FAILURE = 'CANCEL_BATCH_APPROVAL_FAILURE';
export const API_ERROR = 'API_ERROR';
export const STORE_BATCH_BUSINESS_ERROR = 'STORE_BATCH_BUSINESS_ERROR';
export const CREATE_NEW_FASTER_PAYMENT_TEMPLATE = 'CREATE_NEW_FASTER_PAYMENT_TEMPLATE';
export const GO_TO_VIEW_PAYEE_PAGE = 'GO_TO_VIEW_PAYEE_PAGE';
export const GO_TO_EDIT_PAYEE_PAGE = 'GO_TO_EDIT_PAYEE_PAGE';
export const GO_TO_EDIT_CHAPS_PAGE = 'GO_TO_EDIT_CHAPS_PAGE';
export const UPDATE_PAYMENT_ID = 'UPDATE_PAYMENT_ID';

export const updatePaymentId = (id) => ({
	type: UPDATE_PAYMENT_ID,
	id,
});

export const createNewFasterPaymnetTemplate = () => ({
	type: CREATE_NEW_FASTER_PAYMENT_TEMPLATE,
});
export const goToViewPayeePage = () => ({
	type: GO_TO_VIEW_PAYEE_PAGE,
});
export const goToEditPayeePage = (isCOPEdit = false) => ({
	type: GO_TO_EDIT_PAYEE_PAGE,
	payload: { isCOPEdit },
});
export const goToEditChapsPage = () => ({
	type: GO_TO_EDIT_CHAPS_PAGE,
});
export const apiError = () => ({ type: API_ERROR });

export const storeBatchBusinessError = (error) => ({
	type: STORE_BATCH_BUSINESS_ERROR,
	payload: error,
});

export const submitPaymentsForReview = (payments, userId) => {
	const body = JSON.stringify(payments);
	const endpoint = endpoints.multipart.uri;
	const successAction = {
		type: SUBMIT_PAYMENT_REVIEW_SUCCESS,
		meta: { userId },
	};
	return {
		[RSAA]: {
			endpoint,
			method: 'POST',
			types: [SUBMIT_PAYMENT_REVIEW_REQUEST, successAction, SUBMIT_PAYMENT_REVIEW_FAILURE],
			body,
			headers: { 'x-bpi-version': endpoints.multipart.x_bpi_version },
		},
	};
};

export const submitPaymentsForDailyLimitReview = (payments) => {
	const body = JSON.stringify(payments);
	const endpoint = endpoints.multipart.uri;

	return {
		[RSAA]: {
			endpoint,
			method: 'POST',
			types: [
				SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_REQUEST,
				SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_SUCCESS,
				SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_FAILURE,
			],
			body,
			headers: { 'x-bpi-version': endpoints.multipart.x_bpi_version },
		},
	};
};

export const submitRepeatingPaymentForReview = (payment, userId) => {
	const body = JSON.stringify(payment);
	const endpoint = endpoints.authorisation.uri;
	const successAction = {
		type: SUBMIT_REPEATING_PAYMENT_REVIEW_SUCCESS,
		meta: { userId },
	};

	return {
		[RSAA]: {
			endpoint,
			method: 'POST',
			types: [SUBMIT_REPEATING_PAYMENT_REVIEW_REQUEST, successAction, SUBMIT_REPEATING_PAYMENT_REVIEW_FAILURE],
			body,
			headers: { 'x-bpi-version': endpoints.authorisation.x_bpi_version },
		},
	};
};

export const submitConfirmedPayments = (payments) => {
	const body = JSON.stringify(payments);
	const endpoint = endpoints.multipart.uri;

	return {
		[RSAA]: {
			endpoint,
			method: 'POST',
			types: [SUBMIT_CONFIRMED_PAYMENT_REQUEST, SUBMIT_CONFIRMED_PAYMENT_SUCCESS, SUBMIT_CONFIRMED_PAYMENT_FAILURE],
			body,
			headers: { 'x-bpi-version': endpoints.multipart.x_bpi_version },
		},
	};
};

export const submitConfirmedRepeatingPayment = (payment, fromAccount) => {
	// FIXME Update to dispatch different actions for creating vs updating
	const endpoint = has(payment, 'standing_order_uuid') ? endpoints.updateMandate : endpoints.mandate;
	const method = has(payment, 'standing_order_uuid') ? 'PUT' : 'POST';
	const uri = endpoint.resolve(null, null, fromAccount, payment.standing_order_uuid);
	const requestPayment = { ...payment };
	if (requestPayment.standing_order_uuid) {
		delete requestPayment.standing_order_uuid;
	}
	if (method === 'PUT' && requestPayment.isEditMode) {
		delete requestPayment.isEditMode;
	}
	const body = JSON.stringify(requestPayment);
	return {
		[RSAA]: {
			endpoint: uri,
			method,
			types: [
				SUBMIT_CONFIRMED_REPEATING_PAYMENT_REQUEST,
				SUBMIT_CONFIRMED_REPEATING_PAYMENT_SUCCESS,
				SUBMIT_CONFIRMED_REPEATING_PAYMENT_FAILURE,
			],
			body,
			headers: { 'x-bpi-version': endpoint.x_bpi_version },
		},
	};
};

// Chaps batch
const getBatchSubmitAction = (body, paymentCategory, getState) => {
	/* eslint-disable */
	const types =
		paymentCategory === TYPE_CHAPS
			? [
					SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_REQUEST,
					SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_SUCCESS,
					SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_FAILURE,
			  ]
			: [
					SUBMIT_CONFIRMED_BATCH_PAYMENTS_REQUEST,
					SUBMIT_CONFIRMED_BATCH_PAYMENTS_SUCCESS,
					SUBMIT_CONFIRMED_BATCH_PAYMENTS_FAILURE,
			  ];
	/* eslint-enable */
	const state = getState();
	const isFileUploadBatch = isBatchTypeUpload(state);
	if (isFileUploadBatch) {
		const payloadForChunking = JSON.parse(body);
		const fileUploadChunkingDetails = getChunkingInfo(payloadForChunking.batch_list, state, paymentCategory);

		const { isChunkingRequired } = fileUploadChunkingDetails;
		if (isChunkingRequired) {
			const { totalChunks, chunks, totalItems } = fileUploadChunkingDetails;
			return submitMultiPartChunkingRequest(types, totalChunks, chunks, totalItems);
		}
	}
	return {
		[RSAA]: {
			endpoint: endpoints.multipart.uri,
			method: 'POST',
			types,
			body,
			headers: { 'x-bpi-version': endpoints.multipart.x_bpi_version },
		},
	};
};

export const submitBatchForReview = (payments, userId, isChaps) => {
	const body = JSON.stringify(payments);
	const endpoint = endpoints.multipart.uri;
	const successAction = {
		type: isChaps ? SUBMIT_BATCH_CHAPS_REVIEW_SUCCESS : SUBMIT_BATCH_REVIEW_SUCCESS,
		meta: { userId },
	};

	const types = isChaps
		? [SUBMIT_BATCH_CHAPS_REVIEW_REQUEST, successAction, SUBMIT_BATCH_CHAPS_REVIEW_FAILURE]
		: [SUBMIT_BATCH_REVIEW_REQUEST, successAction, SUBMIT_BATCH_REVIEW_FAILURE];

	return {
		[RSAA]: {
			endpoint,
			method: 'POST',
			types,
			body,
			headers: { 'x-bpi-version': endpoints.multipart.x_bpi_version },
		},
	};
};
export const submitBatch = (batch, accounts, paymentCategory, isEditMode) => {
	const endpoint = endpoints.submitBatch.uri;
	const { authorisation } = batch;
	const authorisationStatus = (authorisation && authorisation.status) || null;
	const namedApprovers = { approver_id: get(batch, 'authorisers', []).map((authoriser) => authoriser.id) };
	const authorisersGroup = get(batch, 'authorisersGroup', []);
	const mappedAuthorisersGroup = mapAuthorisersGroup(authorisersGroup);
	const groupApprovers = { approval_group_approver_id: mappedAuthorisersGroup };

	// Check here if 'authorisers' exist we can infer named approvers
	// (or should we use explicit global group approvals toggle value?)
	const authorisersPayload = getAuthorisersPayload(authorisationStatus, namedApprovers, groupApprovers);

	const body = JSON.stringify({
		source_id: uuid.v1(),
		batch_id: batch.id,
		batch_name: batch.name,
		batch_type: get(batch, 'batchType'),
		payment_category: paymentCategory,
		amount: {
			value: parseFloat(batch.total.replace(/,/g, '')),
			currency: 'GBP',
		},
		...(!!authorisersPayload && authorisersPayload),
		isEditMode: !!isEditMode,
		accounts,
	});

	const types =
		paymentCategory === TYPE_CHAPS
			? [SUBMIT_CHAPS_BATCH_REQUEST, SUBMIT_CHAPS_BATCH_SUCCESS, SUBMIT_CHAPS_BATCH_FAILURE]
			: [SUBMIT_BATCH_REQUEST, SUBMIT_BATCH_SUCCESS, SUBMIT_BATCH_FAILURE];

	return {
		[RSAA]: {
			endpoint,
			method: 'POST',
			types,
			body,
			headers: { 'x-bpi-version': endpoints.multipart.x_bpi_version },
		},
	};
};

const dispatchReview = (beneficiaryId) => (dispatch, getState) => {
	const state = getState();
	const userId = getUserId(state);
	if (isBatch(state)) {
		const payments = getPaymentsList(state);
		return dispatch(submitBatchForReview(getBatchToSubmitForReview(state, payments), userId));
	}
	if (isRepeatingPayment(state)) {
		return dispatch(submitRepeatingPaymentForReview(getRepeatingPaymentToSubmitForReview(state), userId));
	}

	return dispatch(submitPaymentsForDailyLimitReview(getPaymentsListToSubmitForDailyLimitReview(state))).then(
		async (response) => {
			const apiResponses = get(response, 'payload.apiResponses', []);

			if (!apiResponses.some(isConflictAndDailyLimitError)) {
				await dispatch(submitPaymentsForReview(getPaymentsListToSubmitForReview(state), userId));
			}
		}
	);
};

export const submitReview = (beneficiaryId) => (dispatch, getState) => {
	const state = getState();
	const paymentsRequireBeneficiary = isPayingInternalAccountsWithoutBeneficiary(state, 'payment');

	if (paymentsRequireBeneficiary.length) {
		const bankId = getBankId(state);
		const { accounts } = state;

		return dispatch(submitBeneficiaries(bankId, paymentsRequireBeneficiary, accounts)).then(() =>
			dispatch(dispatchReview(beneficiaryId))
		);
	}

	return dispatch(dispatchReview(beneficiaryId));
};

export const submitConfirmedBatch = (payments, batch, accounts, paymentCategory, isEditMode) => {
	const body = JSON.stringify(payments);
	return (dispatch, getState) =>
		dispatch(getBatchSubmitAction(body, paymentCategory, getState)).then((response) => {
			const apiResponses = get(response, 'payload.apiResponses', []);
			if (isEmpty(apiResponses) || hasServerError(apiResponses)) {
				return dispatch(apiError());
			}
			if (hasConflictError(apiResponses)) {
				if (hasMissedDeadlineError(apiResponses)) return null;
				const conflictErrorResponse = getConflictResponse(apiResponses);
				const error = get(conflictErrorResponse, 'body.error', {});
				return dispatch(storeBatchBusinessError(error));
			}
			return dispatch(submitBatch(batch, accounts, paymentCategory, isEditMode)).then((response) => response);
		});
};

export const cancelPaymentApproval = (paymentId, account) => {
	const endpoint = endpoints.cancelPaymentApproval;

	const uri = endpoint.resolve(null, null, account, paymentId);
	return {
		[RSAA]: {
			endpoint: uri,
			method: 'DELETE',
			types: [CANCEL_PAYMENT_APPROVAL_REQUEST, CANCEL_PAYMENT_APPROVAL_SUCCESS, CANCEL_PAYMENT_APPROVAL_FAILURE],
			headers: { 'x-bpi-version': endpoints.cancelPaymentApproval.x_bpi_version },
		},
	};
};

export const submitConfirmedEditedPayment = (payments, accountId, getState) => (dispatch) =>
	dispatch(cancelPaymentApproval(getPaymentContextId(getState()), accountId)).then((response) => {
		if (response.type === CANCEL_PAYMENT_APPROVAL_SUCCESS) {
			return dispatch(submitConfirmedPayments(payments));
		}
		return response;
	});

export const submitConfirmedEditedRepeatingPayment = (payment, account, getState) => (dispatch) =>
	dispatch(cancelPaymentApproval(getPaymentContextId(getState()), account)).then((response) => {
		if (response.type === CANCEL_PAYMENT_APPROVAL_SUCCESS) {
			return dispatch(submitConfirmedRepeatingPayment(payment, account));
		}
		return response;
	});

export const submitConfirmedEditedBatch = (payments, batch, account, fromAccounts, paymentCategory) => (dispatch) =>
	dispatch(cancelPaymentApproval(batch.context_id, account)).then((response) => {
		if (response.type === CANCEL_PAYMENT_APPROVAL_SUCCESS) {
			const isEditMode = true;
			return dispatch(submitConfirmedBatch(payments, batch, fromAccounts, paymentCategory, isEditMode));
		}
		return response;
	});

export const getBatchDetails = (state, batchTotal) => {
	const authorisation = getBatchAuthorisation(state);
	const paymentCategory = getPaymentCategory(state);
	const batchName = getBatchName(state);
	const batchId = getBatchId(state);
	const batchType = getBatchType(state);
	const authorisers = getBatchAuthorisers(state);
	const authorisersGroup = getBatchGroupAuthorisers(state);
	const batch = {
		authorisation,
		id: batchId,
		total: batchTotal,
		name: batchName,
		authorisers,
		authorisersGroup,
		context_id: getBatchContextId(state),
		batchType,
	};
	return { batch, paymentCategory };
};

export const submitConfirmed = () => (dispatch, getState) => {
	const state = getState();
	const batchFromAccounts = getFromAccounts(state);
	const fromAccount = getFromAccount(state);
	const payments = getConfirmedPaymentsToSubmit(state);

	if (isBatch(state)) {
		const batchTotal = getPaymentsTotal(state);
		const { batch, paymentCategory } = getBatchDetails(state, batchTotal);
		if (isAuthorisationEdit(state)) {
			return dispatch(submitConfirmedEditedBatch(payments, batch, fromAccount, batchFromAccounts, paymentCategory));
		}
		return dispatch(submitConfirmedBatch(payments, batch, batchFromAccounts, paymentCategory));
	} else if (isRepeatingPayment(state)) {
		if (isAuthorisationEdit(state)) {
			return dispatch(submitConfirmedEditedRepeatingPayment(payments, fromAccount, getState));
		}
		return dispatch(submitConfirmedRepeatingPayment(payments, fromAccount));
	} else if (isAuthorisationEdit(state)) {
		return dispatch(submitConfirmedEditedPayment(payments, fromAccount, getState));
	}
	return dispatch(submitConfirmedPayments(payments));
};
